const styles = {
  tabsContainer: {
    '& .MuiTabPanel-root': {
      paddingTop: theme => theme.spacing(2),
    },
    '& .MuiTabs-flexContainer': {
      '& .MuiButton-root': {
        ml: 'auto',
      },
    },
  },
}

export default styles
